import { createSlice } from '@reduxjs/toolkit';
import { URLRoutes } from '../../config'

export const drawerMenu = createSlice({
    name: 'drawerMenu',
    initialState: {
        urlReturn: null,
        returnBtnSmallVm: true,
        returnBtnVw: true,
        infoBtnVW: true,
        drawerIsOpen: false,
        mainLogo: true
    },
    reducers: {
        setUrl: (state, { payload }) => {
            state.urlReturn = payload;
        },
        setBtnSmallVm: (state, { payload }) => {
            state.returnBtnSmallVm = payload;
        },
        setBtnVw: (state, { payload }) => {
            state.returnBtnVw = payload;
        },
        setInfoBtnVW: (state, { payload }) => {
            state.infoBtnVW = payload;
        },
        setDrawerIsOpen: (state, { payload }) => {
            state.drawerIsOpen = payload;
        },
        setMainLogo: (state, { payload }) => {
            state.mainLogo = payload;
        }
    }
});

export const { setUrl, setBtnSmallVm, setBtnVw, setInfoBtnVW, setDrawerIsOpen, setMainLogo } = drawerMenu.actions;
